import { DynamicModule, Module } from '@nestjs/common';
import { APP_GUARD, Reflector } from '@nestjs/core';
import { AuthNPaasModuleOptions } from './types';
import { AUTHNPAAS_MODULE_OPTIONS } from './const';
import { AuthNPaasGuard } from './guards/authnpaas.guard';
import { AuthNPaasService } from './services/authnpaas.service';
import { AuthNPaasController } from './controllers/authnpaas.controller';

@Module({})
export class AuthNPaasModule {
  static forRoot(options?: AuthNPaasModuleOptions): DynamicModule {
    return {
      module: AuthNPaasModule,
      global: true,
      controllers: [AuthNPaasController],
      providers: [
        // 配置提供者
        {
          provide: AUTHNPAAS_MODULE_OPTIONS,
          useValue: {
            ...(options || {}),
          },
        },
        // 核心服务
        Reflector,
        // 服务提供者
        AuthNPaasGuard,
        AuthNPaasService,
        // 守卫提供者
        {
          provide: APP_GUARD,
          useClass: AuthNPaasGuard,
        },
      ],
      exports: [AuthNPaasService],
    };
  }
}
